import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getBrandConfig } from '../util/domain-utils';

const CancelPage = () => {
  const navigate = useNavigate();
  const brand = getBrandConfig();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="max-w-md w-full rounded-xl overflow-hidden">
        <div className="p-8">
          <div className="flex justify-center mb-6">
            <div className="h-16 w-16 rounded-full bg-red-100 flex items-center justify-center">
              <svg className="h-8 w-8 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
          </div>
          
          <h1 className="text-center text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h1>
          <p className="text-center text-gray-600 mb-8">
            Your payment has been cancelled. No charges were made to your account.
          </p>
          
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-lg p-4">
              <h3 className="text-lg font-medium text-gray-900 mb-3">
                What would you like to do next?
              </h3>
              
              <div className="space-y-3">
                <button 
                  onClick={() => navigate('/plans')} 
                  className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  Return to Pricing
                </button>
                
                <button 
                  onClick={() => navigate('/dashboard')} 
                  className="w-full flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  Go to Dashboard
                </button>
              </div>
            </div>
            
            <div className="border-t border-gray-200 pt-4">
              <div className="text-center text-sm">
                <p className="text-gray-600">
                  Having issues with your payment?
                </p>
                <a 
                  href="mailto:support@maxresumes.com" 
                  className="font-medium text-blue-600 hover:text-blue-500 inline-flex items-center mt-1"
                >
                  <svg className="w-4 h-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Contact Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-8 text-center text-sm text-gray-500">
        <p>
          &copy; {new Date().getFullYear()} {brand.name}. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default CancelPage;